var React = require('react');

function YellowArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30.9056 28L29.2728 29.7812L5.52281 53.5312L3.89 55.1641L0.475937 51.75L2.10875 50.1172L24.2259 28L2.10875 6.03125L0.475937 4.25L3.89 0.984375L5.52281 2.61719L29.2728 26.3672L30.9056 28Z","fill":"white"}));
}

YellowArrow.defaultProps = {"width":"31","height":"20","viewBox":"0 0 31 56","fill":"none"};

module.exports = YellowArrow;

YellowArrow.default = YellowArrow;
